import { render, staticRenderFns } from "./SendOrderShopee.vue?vue&type=template&id=2250106f&scoped=true"
import script from "./SendOrderShopee.vue?vue&type=script&lang=js"
export * from "./SendOrderShopee.vue?vue&type=script&lang=js"
import style0 from "./SendOrderShopee.vue?vue&type=style&index=0&id=2250106f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250106f",
  null
  
)

export default component.exports